import { render } from "./RecordList.vue?vue&type=template&id=31bdd64e&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"

import "./RecordList.vue?vue&type=style&index=0&id=31bdd64e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bdd64e"]])

export default __exports__